"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.YAHOO_TEMPLATE_URL = exports.yahooImageUrl = exports.uploadYahooImage = exports.importYahooArticleDocx = exports.downloadYahooArticleXml = exports.updateYahooArticle = exports.createYahooArticle = exports.getYahooArticle = exports.listYahooArticles = void 0;
const YahooArticle_1 = require("domain/YahooArticle");
const ApiClient_1 = require("../ApiClient");
const listYahooArticles = () => ApiClient_1.apiClient.get('/api/yahoo-articles');
exports.listYahooArticles = listYahooArticles;
const getYahooArticle = (id) => ApiClient_1.apiClient.get(`/api/yahoo-articles/${encodeURIComponent(id)}`);
exports.getYahooArticle = getYahooArticle;
const createYahooArticle = (input) => ApiClient_1.apiClient.post('/api/yahoo-articles', input);
exports.createYahooArticle = createYahooArticle;
const updateYahooArticle = (id, input) => ApiClient_1.apiClient.put(`/api/yahoo-articles/${encodeURIComponent(id)}`, input);
exports.updateYahooArticle = updateYahooArticle;
// Takes the next RevisionId on the server.
const downloadYahooArticleXml = (id) => ApiClient_1.apiClient.post(`/api/yahoo-articles/${encodeURIComponent(id)}/xml`);
exports.downloadYahooArticleXml = downloadYahooArticleXml;
const importYahooArticleDocx = (docxBase64) => ApiClient_1.apiClient.post('/api/yahoo-articles/import-docx', { docxBase64 });
exports.importYahooArticleDocx = importYahooArticleDocx;
const uploadYahooImage = (imageBase64) => ApiClient_1.apiClient.post('/api/yahoo-images', { imageBase64 });
exports.uploadYahooImage = uploadYahooImage;
// Draft images are private: the preview reads them through the API (same-origin
// cookie). Only our own uploaded keys are ever shown; anything else renders nothing.
const yahooImageUrl = (src) => ((0, YahooArticle_1.isYahooImageKey)(src) ? `/api/yahoo-images/${src}` : '');
exports.yahooImageUrl = yahooImageUrl;
exports.YAHOO_TEMPLATE_URL = '/yahoo-article-template.docx';
